export default __webpack_public_path__ + "static/media/RECORDS.6012785b.svg";